<template>
  <div class="bm-player-apply" v-cloak >
    <div class="header" >
      <div class="title">{{match.name}}</div>
      <div class="team-box">
        <div class='left'>
          <div class='name'>
            <div>
               <img class="logo" v-if="team.badge" :src="teamLogo" >
               <img class="logo" v-else src="@/assets/images/team-logo-empty.png" />
            </div>
            <div class="team-name">{{team.name}}</div>
          </div>
        </div>
        <div class='right'>
          <van-button size="small" v-if="player.isTeamLeader==1" type="primary" @click="goTeamPlayerPage">管理球队</van-button>
        </div>
      </div>
      <div class='infotext'>根据组委会要求，请填写参赛球员实名信息</div>
    </div>
    <div class="form" >
      <van-field
              v-model="userForm.name"
              label="姓名"
              placeholder="请输入姓名"/>
      <van-field
              label="身份证"
              v-model="userForm.certNum"
              placeholder="请输入身份证号码"/>

      <div class='radio' v-if="player.isTeamLeader==1">
        <van-radio-group v-model="userForm.forSelf">
          <van-radio class="radio-item" :name="0"> 为队员报名</van-radio>
          <van-radio class="radio-item" :name="1"> 为本人报名</van-radio>
        </van-radio-group>
      </div>
      <div class='next-btn'>
        <van-button  @click="geNextPage" type="primary" block>下一步</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { getUserInfo } from '@/libs/cookie-storage'
import { getPassport } from '@/libs/passport'
import { getAssociationMatchPlayerSignupInfo, getAssociationMatchPlayerSignupInfoByCertInfo } from '@/api/team'

import {Cell, CellGroup, Button, SwipeCell, Toast, Dialog} from 'vant'
import { ImageFormat } from '@/utils/'
Vue.use(Cell).use(CellGroup).use(Button).use(SwipeCell).use(Toast)

export default {
  name: 'TeamInfo',
  data() {
    return {
      userForm: {
        name: '',
        certNum: '',
        forSelf: 0
      },
      matchId: '',
      teamId: '',
      match: {},
      association: {},
      team: {},
      player: {}
    }
  },
  computed: {
    teamLogo() {
      return ImageFormat.imageView(this.team.badge, 104, 104)
    }
  },
  created() {
  },
  mounted() {
    this.teamId = this.$route.query.teamId
    this.matchId = this.$route.query.matchId
    getPassport().then((response) => {
      if (response) {
        this.getAssociationMatchPlayerSignupInfo()
      }
    })
  },
  methods: {
    geNextPage() {
      this.getAssociationMatchPlayerSignupInfoByCertInfo()
    },
    goTeamPlayerPage() {
      this.$router.push({
        path: '/invite-team-edit/info',
        query: {
          teamId: this.teamId,
          matchId: this.matchId
        }
      })
    },
    getAssociationMatchPlayerSignupInfo() {
      const userInfo = getUserInfo()
      const params = {
        matchId: this.matchId,
        teamId: this.teamId
      }
      if (userInfo.id) {
        params.userId = userInfo.id
      }
      getAssociationMatchPlayerSignupInfo(params).then((response) => {
        if (response) {
          this.match = response.data.match
          this.association = response.data.association
          this.team = response.data.team
          this.player = response.data.player || {}
          // this.player = {}
          if (this.player.isTeamLeader !== '1') { // 不是队长
            if (this.player.signupAlready === '1') {
              //  调转查看报名信息
              this.$router.push({
                path: '/participate/player-info',
                query: {
                  teamId: this.teamId,
                  matchId: this.matchId,
                  name: this.player.trueName,
                  certNum: this.player.certNum
                }
              })
              return
            }
            // this.userForm.name = this.player.trueName
            // this.userForm.certNum = this.player.certNum
          }
          this.userForm.forSelf = 0

          const title = this.association.name + '赛事注册报名'
          const shareLogo = this.match.logo
          const arr = window.location.href.split('index.html')
          const shareUrl = arr[0] + 'index.html#/participate/player-apply?teamId=' + this.teamId + '&matchId=' + this.matchId
          const shareData = {
            title: title,
            link: shareUrl,
            image: ImageFormat.squareImageView(shareLogo, 120),
            abstract: this.match.name
          }
          this.wxShare(shareData)
        }
      })
    },
    getAssociationMatchPlayerSignupInfoByCertInfo() {
      if (!this.userForm.name || !this.userForm.certNum) {
        Toast('用户信息不能为空')
        return
      }
      const params = {
        matchId: this.matchId,
        teamId: this.teamId,
        name: this.userForm.name,
        certNum: this.userForm.certNum
      }
      getAssociationMatchPlayerSignupInfoByCertInfo(params).then((response) => {
        const data = response.data
        if (!data.player) {
          Dialog.confirm({
            title: '操作',
            message: '未查询到该球员在此协会注册信息，请进入新球员报名流程'
          }).then(() => {
            // on confirm
            if (this.player.isTeamLeader === '1' && this.userForm.forSelf === 0) { // 当前用户是否为队长且为球员报名
              this.$router.push({
                path: '/invite-team-edit/info',
                query: {
                  teamId: this.teamId,
                  matchId: this.matchId
                }
              })
            } else {
              this.$router.push({
                path: '/invite-player',
                query: {
                  teamId: this.teamId,
                  matchId: this.matchId
                }
              })
            }
          }).catch(() => {
            // on cancel
          })
        } else { // 协会注册过
          this.clientPlayer = data.player
          this.$router.push({
            path: '/participate/player-info',
            query: {
              teamId: this.teamId,
              matchId: this.matchId,
              name: this.userForm.name,
              certNum: this.userForm.certNum,
              forSelf: this.userForm.forSelf
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
.bm-player-apply{
  padding: 15px;
  .header{
    .title{
      padding-top: 20px;
      font-size: 16px;
      text-align: center;
    }
    .team-box{
      font-size: 14px;
      position: relative;
      margin-top: 15px;
      .left{
        float: left;
        .logo {
          width: 52px;
          height: 52px;
          border-radius: 4px;
        }
      }
      .right{
        float: right;
        padding-top: 25px;
      }
      .name{
        padding-top: 20px;
        font-size: 14px;
        text-align: left;
      }
      .team-name {
        position: absolute;
        top: 36px;
        left: 60px;
        width: 220px;
      }
    }
    .infotext{
      text-align: left;
      margin-top: 20px;
      font-size: 12px;
      padding: 15px 0;
      clear: both;
    }
  }
  .form{
    .infotext{
      font-size: 10px;
      text-align: center;
      margin: 10px;
    }
    .radio{
      padding: 15px;
      .radio-item {
        display: inline-block;
        margin-right: 15px;
      }
    }
    .next-btn{
      padding: 10px;
      margin-top: 10px;
      text-align: center;
      .next{

      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/team/participate/player-apply.vue